<div class="releaseOrderList" [style.border-style]="borderStye" [style.border-color]="borderColor" fxLayout="column">
    <div fxLayout="row" fxFlex="100" class="justify-content-between ">
        <div class="ROdetails shimmer">
            <span class="dtitle">Release Order:</span><span>item.do_reference_no</span>
        </div>
        <div class="shimmer">
            <span>Pending pick-up: 10/10</span>
        </div>
    </div>
    <div fxLayout="row" fxFlex="100" class="ROdetailSet ">
        <div fxLayout="column" fxFlex="65" class="shimmer">
            <div class="ROdetails">
                <span class="dtitle" fxFlex="25">Depot:</span><span
                    fxFlex="70">item.depot?.display_name,item.depot?.address</span>
            </div>
            <div class="ROdetails">
                <span class="dtitle" fxFlex="25">Contact person:</span><span fxFlex="70">contact?.first_name
                    contact?.last_name,<br>
                    contact?.phone?.as_international </span>
            </div>
        </div>
        <div class="qrCode shimmer" fxFlex="15">
            <span> this is image</span>
        </div>
    </div>
    <div fxLayout="row" class="actionRow">
        <div class="shimmer">
            <span>status</span>
        </div>
        <div class="actionListIcon shimmer">
            <i class="flaticon-delete" matTooltip="Cancel Release Order"></i>
            <i class="flaticon-download" matTooltip="Download Release Order"></i>
            <i class="flaticon-pencil-tool" matTooltip="Edit Release Order"></i>
            <i class="flaticon-share-details" matTooltip="Share Release Order"></i>
        </div>
    </div>
</div>